import {
  CloseOutlined,
  DownOutlined,
  EditOutlined,
  MoreOutlined,
  UpOutlined,
} from "@ant-design/icons";
import styles from "./PolicyTableCSS.css";
import { ConfigProvider, Dropdown, Space, Switch, Table } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import formatDateTime from "utils/formatter/formatDateTime";
import { useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";


const CustomExpandIcon = (props) => {
  return (
    <Space onClick={(e) => props.onExpand(props.record, e)}>
      {props.expanded ? (
        <UpOutlined style={{ fontSize: "16px", color: "gray" }} />
      ) : (
        <DownOutlined style={{ fontSize: "16px", color: "gray" }} />
      )}
    </Space>
  );
};

const PolicyTable = ({
  isLoading = false,
  dataSource = [],
  onEdit = () => { },
  onStatus = () => { },
  onPolicyStatus = () => { },
  onDeletePolicy = () => { },
  onEditPolicyCategory = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    if (i18n.language === "en") {
      return date.format("DD/MM/YYYY HH:mm");
    } else {
      return `${date.format(`DD/MM/${date.year() + 543}`)} ${date.format('HH:mm')} น.`;
    }
  }

  const expandedRowRender = (row = {}) => {
    const columns = [
      {
        title: (
          <div className="text-table" >{t("policy.label.policy_code")}</div>
        ),
        dataIndex: "policyCode",
        key: "policyCode",
        sorter: {
          compare: (a, b) => null,
          multiple: 5,
        },
      },
      {
        title: (
          <div className="text-table">{t("policy.label.policy_name")}</div>
        ),
        dataIndex: "policyName",
        key: "policyName",
        width: "20%",
        sorter: {
          compare: (a, b) => null,
          multiple: 5,
        },
      },

      {
        title: (
          <div className="text-table">{t("policy.label.acknowledge")}</div>
        ),
        dataIndex: "acknowledge",
        key: "acknowledge",
        width: "20%",
        render: (_, record) => {
          return record?.acknowledge === 'Y' ? record.numberOfEmployee : "-"
        }
      },
      {
        title: (
          <div className="text-table">{t("policy.label.last_modified")}</div>
        ),
        dataIndex: "lastModified",
        key: "lastModified",
        render: (_, record) => {
          const { lastModified = {} } = record;
          const name =
            i18n.language === "en" && lastModified.nameEn
              ? lastModified.nameEn
              : lastModified.name;
          return (
            <>
              {name}
              <br />
              {lastModified.lastModifiedDate ? formatDateTime(dayjs(lastModified.lastModifiedDate)) : "-"}
            </>
          );
        },
      },
      {
        title: <div className="text-table">{t("policy.label.status")}</div>,
        dataIndex: "announcementStatus",
        key: "announcementStatus",
        render: (text, record) => (
          <Switch
            checked={text === "Y"}
            onChange={(checked) => {
              onPolicyStatus(checked, {
                ...record,
                policyCategoryId: row.policyCategoryId,
                policyAnnouncementId: row.id
              });
            }}
          // onChange={(checked) => onStatus(checked, row.policyCategoryId)}
          />
        ),
      },
      roles.includes("UPDATE_NEWS_&_POLICY|POLICY") ? {
        title: <div className="text-table">{t("action.action")}</div>,
        key: "action",
        render: (_, record) => (
          <Space size="middle">
            <Dropdown
              menu={{
                items: [
                  {
                    key: "1",
                    onClick: () => onEdit(row, record),
                    label: `${t("action.edit")}`,
                    icon: (
                      <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                    ),
                  },
                  {
                    key: "2",
                    onClick: () => onDeletePolicy(row, record),
                    label: `${t("action.delete")}`,
                    icon: (
                      <CloseOutlined style={{ fontSize: "18px", color: "gray" }} />
                    ),
                  },
                ],
              }}
            >
              <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
            </Dropdown>
          </Space>
        ),
      } : {},
    ];
    const { policyList = [] } = row;
    return (
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#b8ebff !important",
            },
          },
        }}
      >
        <TableAntd
          onHeaderRow={(e) => {
            console.log("e", e);
            return {
              style: {
                fontSize: 100
              }
            }
          }}
          columns={columns}
          dataSource={policyList}
          pagination={false}
          rowKey={(record) => record.policyId}
        />
      </ConfigProvider>

    );
  };

  const columns = [
    {
      title: <div className="text-table">{t("policy.label.category")}</div>,
      dataIndex: "policyCategoryName",
      key: "policyCategoryName",
      sorter: (a, b) =>
        a.policyCategoryName.length - b.policyCategoryName.length,
      width: "50%",
    },
    {
      title: (
        <div className="text-table">{t("policy.label.last_modified")}</div>
      ),
      dataIndex: "lastModified",
      key: "lastModified",
      render: (_, record) => {
        console.log("lastmodify ", record);

        if (record?.update?.nameEn) {
          return (
            <>
              {i18n.language === 'en' ? record?.update?.nameEn + " " + record?.update?.surNameEn : record?.update?.name + " " + record?.update?.surName}
              <br />
              {formatDate(dayjs(record?.update?.lastModifiedDate))}
            </>
          )
        } else {
          return (
            <>
              {i18n.language === 'en' ? record?.create?.nameEn + " " + record?.create?.surNameEn : record?.create?.name + " " + record?.create?.surName}
              <br />
              {formatDate(dayjs(record?.create?.lastModifiedDate))}
            </>
          )
        }

      },
    },
    {
      title: <div className="text-table">{t("policy.label.switch")}</div>,
      dataIndex: "announcementStatus",
      key: "announcementStatus",
      render: (text, record) => (
        <Switch
          checked={text === "Y"}
          onChange={(checked) => onStatus(checked, record)}
        />
      ),
    },
    {
      title: <div className="text-table" >{t("action.action")}</div>,
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                {
                  key: "1",
                  onClick: () => onEditPolicyCategory(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    },
  ];

  return (
    <TableAntd
      className={styles.policyTable}
      loading={isLoading}
      dataSource={dataSource}
      columns={columns}
      rowKey={(record) => record.policyCategoryId}
      expandable={{
        expandedRowRender,
        expandIcon: CustomExpandIcon,
      }}
      scroll={{ x: true }}
    />
  );
};

export default PolicyTable;
